export default __webpack_public_path__ + "static/media/Snd2.cedf2462.mp3";